/* ==========================================================================
   Veylo - interaction layer
   Header shadow on scroll, subtle hero parallax, reveal-on-scroll,
   wishlist, add to cart. Progressive enhancement only.
   ========================================================================== */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- header */

  function initHeader() {
    var headerEl =
      document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    if (!headerEl) return;

    var wrap = headerEl.closest('.shopify-section') || headerEl;
    wrap.classList.add('veylo-headerwrap');

    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        wrap.classList.toggle('veylo-headerwrap--scrolled', window.scrollY > 16);
        ticking = false;
      });
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* -------------------------------------------------------------- parallax */

  function initParallax() {
    if (reduceMotion) return;
    var media = document.querySelector('.veylo-hero__media[data-veylo-parallax]');
    if (!media) return;

    var hero = media.closest('.veylo-hero');
    if (!hero) return;
    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var offset = Math.max(-1, Math.min(1, -rect.top / (rect.height || 1)));
      media.style.transform = 'translate3d(0,' + (offset * 5).toFixed(3) + '%,0)';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ---------------------------------------------------------------- reveal */

  function initReveal(root) {
    var scope = root || document;
    var items = scope.querySelectorAll('[data-veylo-reveal]:not(.is-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );

    Array.prototype.forEach.call(items, function (el) {
      observer.observe(el);
    });
  }

  /* -------------------------------------------------------------- wishlist */

  var WISHLIST_KEY = 'veylo:wishlist';

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(WISHLIST_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable */
    }
  }

  function initWishlist(root) {
    var scope = root || document;
    var buttons = scope.querySelectorAll('[data-veylo-wish]');
    if (!buttons.length) return;

    var list = readWishlist();

    Array.prototype.forEach.call(buttons, function (btn) {
      var handle = btn.getAttribute('data-veylo-wish');
      btn.setAttribute('aria-pressed', list.indexOf(handle) !== -1 ? 'true' : 'false');

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var current = readWishlist();
        var index = current.indexOf(handle);
        if (index === -1) {
          current.push(handle);
          btn.setAttribute('aria-pressed', 'true');
        } else {
          current.splice(index, 1);
          btn.setAttribute('aria-pressed', 'false');
        }
        writeWishlist(current);
      });
    });
  }

  /* ----------------------------------------------------------- add to cart */

  function initAddToCart(root) {
    var scope = root || document;
    var forms = scope.querySelectorAll('form[data-veylo-add]');

    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;

        event.preventDefault();

        var button = form.querySelector('[type="submit"]');
        var original = button ? button.innerHTML : '';
        var idInput = form.querySelector('[name="id"]');
        if (!idInput) return;

        if (button) {
          button.setAttribute('disabled', 'disabled');
          button.innerHTML = 'Adding...';
        }

        var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: Number(idInput.value), quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
          })
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (data) {
            if (data && data.status) throw new Error(data.description || data.message);
            if (data && data.sections) drawer.renderContents(data);
          })
          .catch(function () {
            window.location.href = '/cart';
          })
          .finally(function () {
            if (button) {
              button.removeAttribute('disabled');
              button.innerHTML = original;
            }
          });
      });
    });
  }

  /* ------------------------------------------------------------------ boot */

  function boot(root) {
    initReveal(root);
    initWishlist(root);
    initAddToCart(root);
  }

  function bootAll() {
    initHeader();
    initParallax();
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHeader();
    initParallax();
    boot(event.target);
  });
})();
